import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  input: {
    margin: [theme.spacing(3), 0],
  },
  warning: {
    backgroundColor: theme.palette.colors.warningBackground,
  },
  warningHeader: {
    color: theme.palette.colors.red,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/AnnualGrossIncomeQuestion/useStyles.js